import { useEffect } from 'react';

import { type FormDefinitionResponse } from 'app/modules/FormDefinition/models/definition.types';
import { useGetFormDefinition } from 'app/modules/FormDefinition/services/formDefinition.service';
import { useGetTaxReturnById } from 'app/modules/Reports/TaxReturnList/hooks';
import { type TaxReturn } from 'app/modules/Reports/TaxReturnList/types';

const baseUrl = '/formdefinition';

export const useGetTaxReturnDef: (taxreturnId: string) => {
  loading: boolean;
  data: { taxreturn: TaxReturn | undefined; definition: FormDefinitionResponse | undefined };
  error: any;
} = (taxreturnId: string) => {
  const {
    loading: loadingTaxReturn,
    taxreturn,
    error: errorTaxReturn
  } = useGetTaxReturnById(taxreturnId);
  const {
    loading: loadingDef,
    error: errorDef,
    data: definition,
    execute
  } = useGetFormDefinition(taxreturn!.formVersionId, false);
  const formVersionId = taxreturn?.formVersionId;
  useEffect(() => {
    if (formVersionId) {
      execute({ url: `${baseUrl}/${formVersionId}` });
    }
  }, [formVersionId]);

  const loading = loadingTaxReturn || definition === undefined;
  const error = errorTaxReturn || errorDef;
  return { loading, error, data: { definition, taxreturn } };
};
